export const capitalize = (string) => {
    return [string[0].toUpperCase(), string.slice(1)].join('');
};
